import React, {PropTypes} from 'react';
import {ButtonDropdown, DropdownToggle, DropdownItem, DropdownMenu} from 'reactstrap';

function isFilterOn(itemList, selectedItems) {
  if(selectedItems.length === 0 || selectedItems.length === itemList.length) {
    return false;
  } else {
    return true;
  }
}

const SearchMultiSelect = ({
  isOpen,
  onSelected,
  onToggle,
  itemList,
  selectedItems    
}) => {
  const petTypes = itemList.map((petType) => {
    let checkedClass = '';
    if(selectedItems.includes(petType)) {
      checkedClass = 'multi-checked';
    }

    return (
      <DropdownItem key={petType} 
                    className={checkedClass}
                    toggle={false} 
                    onClick={(e) => {e.target.blur(); onSelected(petType);}}>{petType}</DropdownItem>
    );
  });

  const filterClass = isFilterOn(itemList, selectedItems) ? 'filter-on' : '';

  return (
    <div className="input-group-btn search-panel">
      <ButtonDropdown isOpen={isOpen} toggle={onToggle} className="btn-group input-group-btn search-panel">
        <DropdownToggle className={filterClass}/>
        <DropdownMenu>
          {petTypes}
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  );
};

SearchMultiSelect.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  itemList: PropTypes.array.isRequired,
  onSelected: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  selectedItems: PropTypes.array.isRequired  
};

export default SearchMultiSelect;


/** WEBPACK FOOTER **
 ** ./src/modules/search/components/SearchMultiSelect.js
 **/